import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section id="garantia" aria-labelledby="guarantee-title" className="scroll-mt-16 mx-auto max-w-5xl px-5 py-20 lg:py-24" data-id="element-108" data-mp="1o46konudlsx5">
      <div className="grid items-center gap-8 rounded-3xl bg-plum p-8 ring-1 ring-line sm:p-12 md:grid-cols-[auto_1fr] md:gap-12" data-id="element-109" data-mp="222d7n8xse8i1">
        <div className="flex h-40 w-40 flex-col items-center justify-center rounded-full border-4 border-slime text-center" data-id="element-110" data-mp="1x28spncj1ltx">
          <ShieldCheckIcon className="h-8 w-8 text-slime" aria-hidden="true" data-id="element-111" data-mp="14fnymf4o2vmo" />
          <span className="mt-1 font-display text-4xl font-bold leading-none text-bone" data-id="element-112" data-mp="14dl4pk0e8ico">7 días</span>
          <span className="mt-1 text-xs font-extrabold text-slime" data-id="element-113" data-mp="1j6dfny4t74yg">GARANTÍA TOTAL</span>
        </div>
        <div data-id="element-114" data-mp="1ec0unjnoplkl">
          <h2 id="guarantee-title" className="font-display text-3xl font-bold leading-tight text-bone sm:text-4xl" data-id="element-115" data-mp="qo9f876uksf3">
            7 días para probarlo o te devolvemos el 100%
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-mist" data-id="element-116" data-mp="lnbz005ee8g8">
            Abrís los tomos, empezás a planificar tu Halloween. Si no es lo que esperabas: sin preguntas, sin formularios, sin drama.
          </p>
          <p className="mt-3 text-sm font-semibold text-slime" data-id="element-117" data-mp="ypl0de036x54">Tasa de devoluciones menor al 1%</p>
        </div>
      </div>
    </section>;
}